import React from 'react'
import { Helmet } from 'react-helmet';

function MenuPlanesPrecios() {
  const plans = [
    {
      name: "Plan Free",
      price: "$0 USD",
      features: [
        "Acceso a Lectura Express para un número limitado de documentos por mes.", 
        "Ideal para evaluar rápidamente documentos de licitación y determinar su relevancia.", 
        "Prueba gratuita para conocer la plataforma."
      ],
      colorText: "#85ea80"
    },
    {
      name: "Plan Plata",
      price: "$19.99 USD / mes",
      features: [
        "Acceso ilimitado a Lectura Express.", 
        "Acceso completo a Lectura Completa, con análisis detallado de requisitos clave.", 
        "Organización básica de documentos analizados.",
        "Soporte básico en caso de dudas o incidencias."
      ],
      colorText: "#c4dee9"
    },
    {
      name: "Plan Oro",
      price: "$39.99 USD / mes",
      features: [
        "Todo lo que incluye plan Plata.", 
        "Acceso completo a Lectura Personalizada, con un análisis profundo y adaptado.", 
        "Organización avanzada de documentos con mayor capacidad de almacenamiento.",
        "Soporte prioritario con atención rápida a consultas."
      ],
      colorText: "#b3851c"
    }
  ];

    return (
        <div className="contentLeftPrices">
          <Helmet>
            <title>Planes y Precios de MarketBiz.ai</title>
            <meta
              name="description"
              content="Compara los planes de MarketBiz.ai: Free, Plata y Oro. Elige la opción que se ajuste mejor a tus necesidades de análisis de licitaciones."
            />
            <link rel="canonical" href="https://www.marketbiz.ai/Planes y Precios" />
          </Helmet>
          <h1>Planes y Precios</h1>
          <div className="plans-container">
            {plans.map((plan, index) => (
              <div key={index} className="plan-card">
                <h2 style={{ color: plan.colorText }}>{plan.name}</h2>
                <h3>{plan.price}</h3>
                <ul className="custom-bullets">
                  {plan.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          {/*
          <h2 className="subtitulo">Free</h2>
          <h2>Precio: $0 USD</h2>
          <ul className="custom-bullets">
            <li>Acceso a Lectura Express para un número limitado de documentos por mes.</li>
            <li>Ideal para evaluar rápidamente documentos de licitación y determinar su relevancia.</li>
            <li>Prueba gratuita para conocer la plataforma.</li>
          </ul>

          <h2 className="subtitulo">Plata</h2>
          <h2>Precio: $19.99 USD / mes</h2>
          <ul className="custom-bullets">
            <li>Acceso ilimitado a Lectura Express.</li>
            <li>Acceso completo a Lectura Completa, con análisis detallado de requisitos clave.</li>
            <li>Organización básica de documentos analizados.</li>
            <li>Soporte básico en caso de dudas o incidencias.</li>
          </ul>

          <h2 className="subtitulo">Oro</h2>
          <h2>Precio: $39.99 USD / mes</h2>
          <ul className="custom-bullets">
            <li>Todo lo del plan Plata.</li>
            <li>Acceso completo a Lectura Personalizada, con un análisis profundo y adaptado.</li>
            <li>Organización avanzada de documentos con mayor capacidad de almacenamiento.</li>
            <li>Soporte prioritario con atención rápida a consultas.</li>
          </ul>
          */}
        </div>
    );
}

export default MenuPlanesPrecios;